module.exports = __webpack_public_path__ + "static/media/hearclearpro-2.eae86984.jpg";